export class RcApp extends HTMLElement {
  connectedCallback(): void {
    // Shell component - content rendered via light DOM in the layout
  }
}

customElements.define('rc-app', RcApp);
